import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";

export const newCalendarModal = ({
  t,
  userAccess,
  closeMsg,
  modalData,
  openServiceModal,
}: stdObject) => {
  return {
    title: t("p.new"),
    inputs: [
      { code: "SEV", color: colors.services, active: userAccess.C.C1N },
      { code: "ALA", color: colors.orange, active: false },
    ].map((e: stdObject) => {
      return (
        e.active && {
          label: t(`c.${e.code}`),
          type: "button",
          color: e.color,
          style: { width: "100%" },
          onClick: () => {
            closeMsg();
            switch (e.code) {
              case "SEV":
                openServiceModal({ nextDate: modalData.nextDate });
                break;
              default:
                break;
            }
          },
        }
      );
    }),
  };
};
